module.exports = __webpack_public_path__ + "img/background-forgot-password.610df67a.jpg";